<template>
  <svg
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 24C11.4113 24 10.8525 24.2593 10.4725 24.7089C10.0925 25.1585 9.92989 25.7527 10.0279 26.3331C10.5847 29.6288 12.3021 32.6165 14.8698 34.7563C17.4303 36.89 20.6678 38.0401 24 38.0002C27.3322 38.0401 30.5697 36.89 33.1302 34.7563C35.6979 32.6165 37.4153 29.6288 37.9721 26.3331C38.0701 25.7527 37.9075 25.1585 37.5275 24.7089C37.1475 24.2593 36.5887 24 36 24H12ZM17.4305 31.6834C16.2267 30.6802 15.2845 29.416 14.6667 28H33.3333C32.7155 29.416 31.7733 30.6802 30.5695 31.6834C28.7354 33.2118 26.4151 34.0335 24.0279 34.0002L24.0095 34L23.9721 34.0002C21.5849 34.0335 19.2646 33.2118 17.4305 31.6834Z"
    />
    <path
      d="M16 18C16 16.8954 16.8954 16 18 16H18.02C19.1246 16 20.02 16.8954 20.02 18C20.02 19.1046 19.1246 20 18.02 20H18C16.8954 20 16 19.1046 16 18Z"
    />
    <path
      d="M30 16C28.8954 16 28 16.8954 28 18C28 19.1046 28.8954 20 30 20H30.02C31.1246 20 32.02 19.1046 32.02 18C32.02 16.8954 31.1246 16 30.02 16H30Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M24 2C11.8497 2 2 11.8497 2 24C2 36.1503 11.8497 46 24 46C36.1503 46 46 36.1503 46 24C46 11.8497 36.1503 2 24 2ZM6 24C6 14.0589 14.0589 6 24 6C33.9411 6 42 14.0589 42 24C42 33.9411 33.9411 42 24 42C14.0589 42 6 33.9411 6 24Z"
    />
  </svg>
</template>
